import type { FgaAssignableRelation } from './generated/model'

/**
 * The agreement permission vocabulary a permission set configures. Orthogonal rather than tiered, so
 * one toggle is one tuple.
 */
export const AGREEMENT_PERMISSIONS = [
  'view',
  'edit',
  'cancel',
  'delete',
  'view_related_supplier',
  'view_related_requests',
  'manage_renewals',
  'view_documents',
  'edit_documents',
  'manage_documents',
  'administer',
] as const

export type AgreementPermission = (typeof AGREEMENT_PERMISSIONS)[number]

export const agreementGrantsRelation = (
  permission: AgreementPermission
): Extract<FgaAssignableRelation<'agreement_permission_set'>, `grants_${string}`> => `grants_${permission}`
